import { AuthenticationEmailAvailability } from '@mindfulchefuk/api-client'
import errorHandler from '@mindfulchefuk/utils/errorHandler'

export const emailIsAvailable = async (email: string): Promise<boolean> => {
  try {
    const emailAvailbility = new AuthenticationEmailAvailability({
      email,
    })

    const success = await emailAvailbility.save()
    return success ? emailAvailbility.available : false
  } catch (err) {
    errorHandler(err)
  }
}
